import React from "react"
import propTypes from "prop-types"

const Tag = ({ children, className }) => {
  return (
    <li className="status-tags_wrap">
      <div className={["status-tags_tag", className].join(" ")}>{children}</div>
    </li>
  )
}

Tag.propTypes = {
  children: propTypes.string.isRequired,
  className: propTypes.string.isRequired
}

export default Tag
